import Breadcrumb from "../../components/Breadcrumbs/Breadcrumb"
import ExamListComponent from "../../components/Exams/ExamListComponent"

const ExamList = () => {
  return (
    <>
      <Breadcrumb pageName="Exam Detail" />
      <ExamListComponent />
    </>
  )
}

export default ExamList